import React from 'react'
import { FilterGroup } from '../Gifts/GiftsFundTableFilters'
import RelatedBrandsMultiSelect from '../UtmBuilder/RelatedBrandsMultiSelect'
import GiftFundCategoryPicker from '../Gifts/GiftFundCategoryPicker'
import AmeCampaignProductMultiSelect from './AmeCampaignProductMultiSelect'
import {
  AME_CAMPAIGN_SCOPE,
  AME_CAMPAIGN_SCOPE_LABELS,
  AME_INCLUDE_MODE,
  AME_INCLUDE_MODE_LABELS,
} from '../../../api/marketing/ameCampaigns/ameCampaignConstants'

const SCOPE_OPTIONS = [
  { value: AME_CAMPAIGN_SCOPE.all, label: AME_CAMPAIGN_SCOPE_LABELS.all },
  { value: AME_CAMPAIGN_SCOPE.premium, label: AME_CAMPAIGN_SCOPE_LABELS.premium },
  { value: AME_CAMPAIGN_SCOPE.outlet, label: AME_CAMPAIGN_SCOPE_LABELS.outlet },
]

const INCLUDE_OPTIONS = [
  { value: AME_INCLUDE_MODE.allInScope, label: AME_INCLUDE_MODE_LABELS.allInScope },
  { value: AME_INCLUDE_MODE.rules, label: AME_INCLUDE_MODE_LABELS.rules },
  { value: AME_INCLUDE_MODE.products, label: AME_INCLUDE_MODE_LABELS.products },
]

function AmeCampaignAssortmentFields({
  giftStyles,
  scope,
  includeMode,
  includeBrands,
  includeCategories,
  includeProducts,
  excludeBrands,
  excludeCategories,
  excludeProducts,
  brands,
  brandsLoading,
  brandsError,
  taxonomyNodes,
  searchIndex,
  productFilters,
  productsLoading,
  productsError,
  onLoadProducts,
  onChange,
}) {
  return (
    <>
      <div className={giftStyles.filters}>
        <FilterGroup label="Область асортименту" value={scope} options={SCOPE_OPTIONS} onChange={(next) => onChange({ scope: next })} />
        <FilterGroup
          label="Включення"
          value={includeMode}
          options={INCLUDE_OPTIONS}
          onChange={(next) => onChange({ includeMode: next })}
        />
      </div>

      {includeMode === AME_INCLUDE_MODE.rules ? (
        <div className={giftStyles.fields}>
          <RelatedBrandsMultiSelect
            brands={brands}
            isLoading={brandsLoading}
            loadError={brandsError}
            value={includeBrands}
            onChange={(next) => onChange({ includeBrands: next })}
            label="Бренди (АБО всередині списку)"
          />
          <GiftFundCategoryPicker
            value={includeCategories}
            onChange={(next) => onChange({ includeCategories: next })}
            nodes={taxonomyNodes}
            label="Категорії (з нащадками, АБО всередині списку)"
            popupTitle="Оберіть категорію включення"
          />
          <p className={giftStyles.typeLockedHint}>Між брендами та категоріями діє правило «І».</p>
        </div>
      ) : null}

      {includeMode === AME_INCLUDE_MODE.products ? (
        <AmeCampaignProductMultiSelect
          value={includeProducts}
          onChange={(next) => onChange({ includeProducts: next })}
          searchIndex={searchIndex}
          filters={productFilters}
          isLoading={productsLoading}
          loadError={productsError}
          onLoadRequest={onLoadProducts}
          label="Конкретні товари"
        />
      ) : null}

      <p className={giftStyles.sectionLabel}>Виключення (мають пріоритет)</p>
      <RelatedBrandsMultiSelect
        brands={brands}
        isLoading={brandsLoading}
        loadError={brandsError}
        value={excludeBrands}
        onChange={(next) => onChange({ excludeBrands: next })}
        label="Бренди-виключення"
      />
      <GiftFundCategoryPicker
        value={excludeCategories}
        onChange={(next) => onChange({ excludeCategories: next })}
        nodes={taxonomyNodes}
        label="Категорії-виключення"
        popupTitle="Оберіть категорію виключення"
      />
      <AmeCampaignProductMultiSelect
        value={excludeProducts}
        onChange={(next) => onChange({ excludeProducts: next })}
        searchIndex={searchIndex}
        filters={productFilters}
        isLoading={productsLoading}
        loadError={productsError}
        onLoadRequest={onLoadProducts}
        label="Товари-виключення"
      />
    </>
  )
}

export default AmeCampaignAssortmentFields
